import {
  TREASURE_CHEST_RIVE_LEVEL_1,
  TREASURE_CHEST_RIVE_LEVEL_2,
  TREASURE_CHEST_RIVE_LEVEL_3,
  TREASURE_CHEST_RIVE_LEVEL_4,
  TREASURE_CHEST_RIVE_LEVEL_5,
  TREASURE_CHEST_RIVE_LEVEL_6,
  TREASURE_CHEST_RIVE_LEVEL_7,
  TREASURE_CHEST_RIVE_LEVEL_8,
  TREASURE_CHEST_RIVE_LEVEL_9,
  TREASURE_CHEST_RIVE_LEVEL_10,
  TREASURE_CHEST_RIVE_LEVEL_11,
  TREASURE_CHEST_RIVE_LEVEL_12,
} from "@/constants/assets"

// Level to Rive file mapping
const CHEST_LEVEL_TO_FILE_MAP: Record<number, string> = {
  1: TREASURE_CHEST_RIVE_LEVEL_1,
  2: TREASURE_CHEST_RIVE_LEVEL_2,
  3: TREASURE_CHEST_RIVE_LEVEL_3,
  4: TREASURE_CHEST_RIVE_LEVEL_4,
  5: TREASURE_CHEST_RIVE_LEVEL_5,
  6: TREASURE_CHEST_RIVE_LEVEL_6,
  7: TREASURE_CHEST_RIVE_LEVEL_7,
  8: TREASURE_CHEST_RIVE_LEVEL_8,
  9: TREASURE_CHEST_RIVE_LEVEL_9,
  10: TREASURE_CHEST_RIVE_LEVEL_10,
  11: TREASURE_CHEST_RIVE_LEVEL_11,
  12: TREASURE_CHEST_RIVE_LEVEL_12,
}

/**
 * Get the Rive file path for a given chest level
 * @param level - The chest level (1-12)
 * @returns The path to the appropriate Rive file
 */
export function getChestRiveFile(level: number): string {
  const clampedLevel = Math.max(1, Math.min(12, level))
  return CHEST_LEVEL_TO_FILE_MAP[clampedLevel] || TREASURE_CHEST_RIVE_LEVEL_1
}
